export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8116.318957cd.jpg";